import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOwnership } from "@core/debug";
import { factory, Modal as PlasmaModal } from "@coveord/plasma-mantine";
export var Modal = factory(function(_param, ref) {
    var backendOwner = _param.backendOwner, framework = _param.framework, frontendOwner = _param.frontendOwner, props = _object_without_properties(_param, [
        "backendOwner",
        "framework",
        "frontendOwner"
    ]);
    useOwnership({
        backendOwner: backendOwner,
        framework: framework,
        frontendOwner: frontendOwner,
        invisible: !props.opened
    });
    return /*#__PURE__*/ _jsx(PlasmaModal, _object_spread({
        ref: ref
    }, props));
});
var ModalRoot = factory(function(_param, ref) {
    var backendOwner = _param.backendOwner, framework = _param.framework, frontendOwner = _param.frontendOwner, props = _object_without_properties(_param, [
        "backendOwner",
        "framework",
        "frontendOwner"
    ]);
    useOwnership({
        backendOwner: backendOwner,
        framework: framework,
        frontendOwner: frontendOwner,
        invisible: !props.opened
    });
    return /*#__PURE__*/ _jsx(PlasmaModal.Root, _object_spread({
        ref: ref
    }, props));
});
Modal.Root = ModalRoot;
Modal.Body = PlasmaModal.Body;
Modal.Overlay = PlasmaModal.Overlay;
Modal.Content = PlasmaModal.Content;
Modal.Header = PlasmaModal.Header;
Modal.Title = PlasmaModal.Title;
Modal.CloseButton = PlasmaModal.CloseButton;
Modal.Footer = PlasmaModal.Footer;
Modal.Stack = PlasmaModal.Stack;

//# sourceMappingURL=Modal.js.map